<template>
    <div class="relative h-screen overflow-y-auto bg-gray-50">
        <header
            class="bg-red-50 p-4 flex flex-wrap gap-4 items-center justify-between shadow-[0_0_0_0.0625rem] shadow-red-700/10"
        >
            <div class="flex gap-4 items-center font-semibold text-gray-700 text-5xl">
                <WarningIcon class="size-12 text-red-600" />
                <h1 class="hyphens-auto text-red-700">{{ $t('not-found-page') }}</h1>
            </div>
        </header>

        <main class="pt-4">
            <div class="p-4 shadow-[0_0_0_0.0625rem] shadow-red-700/10 bg-red-50 font-light text-red-700 space-y-2">
                <p class="font-semibold text-xl">
                    {{ $t('not-found-page-or-missing-permissions') }}
                </p>
                <div>
                    <p class="font-medium">{{ $t('not-found-page-suggestions-headline') }}</p>
                    <ul class="list-[square] list-inside">
                        <li>{{ $t('not-found-page-suggestion-reload') }}</li>
                        <li>{{ $t('not-found-page-suggestion-check-url') }}</li>
                        <li>{{ $t('not-found-page-suggestion-check-account') }}</li>
                        <li>{{ $t('not-found-page-suggestion-go-home') }}</li>
                    </ul>
                </div>

                <div>
                    <p>
                        {{ $t('not-found-page-contact-capacity-management') }}
                    </p>
                    <div class="flex flex-wrap gap-1.5 items-center">
                        <MailIcon class="size-4 text-red-600" />
                        <p>
                            <a
                                href="mailto:space.cap@koelnmesse.de"
                                class="underline hover:text-red-800 active:text-red-900 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-red-700 focus-visible:ring-offset-2 rounded-xs"
                            >
                                {{ $t('not-found-page-mail') }}
                            </a>
                        </p>
                    </div>
                </div>

                <LinkButton to="/" variant="Neutral-Light" size="Small">
                    {{ $t('not-found-page-home-button-label') }}
                </LinkButton>
            </div>
        </main>
    </div>
</template>

<script setup lang="ts">
import LinkButton from '../Button/LinkButton.vue';
import MailIcon from '../Icon/MailIcon.vue';
import WarningIcon from '../Icon/WarningIcon.vue';
</script>
